import React from 'react';

export const PrivacyInformation = ({ pageLocales }) => {
  return (
    <div className="sign-up-form__privacy-information">
      <h4>{pageLocales.common.privacy}</h4>
      <p>{pageLocales.common.byCreating}</p>
      <div>
        <a target="_blank" href="https://simventure.com/terms-and-conditions/">
          {pageLocales.common.terms}
        </a>
        <a target="_blank" href="https://simventure.com/policies/">
          {pageLocales.common.privacyPolicy}
        </a>
        <a target="_blank" href="https://simventure.com/terms-and-conditions/">
          {pageLocales.common.accessibility}
        </a>
      </div>
    </div>
  );
};
